import { Navigate, Route, Routes } from "react-router-dom";
import { useAuth } from "./auth";
import { Layout } from "./components/Layout";
import { LoginPage } from "./pages/LoginPage";
import { DashboardPage } from "./pages/DashboardPage";
import { MyAccessPage } from "./pages/MyAccessPage";
import { UsersPage } from "./pages/UsersPage";
import { DatabasesPage } from "./pages/DatabasesPage";

function ProtectedRoute({ children, adminOnly = false }: { children: JSX.Element; adminOnly?: boolean }) {
  const { token, me, loading } = useAuth();
  if (!token) return <Navigate to="/login" replace />;
  if (loading) return <FullScreenSpinner />;
  if (adminOnly && me && !me.is_admin) return <Navigate to="/" replace />;
  return children;
}

function FullScreenSpinner() {
  return (
    <div className="flex h-screen items-center justify-center text-slate-500 text-sm">
      Loading…
    </div>
  );
}

export default function App() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route
        element={
          <ProtectedRoute>
            <Layout />
          </ProtectedRoute>
        }
      >
        <Route path="/" element={<DashboardPage />} />
        <Route path="/me/grants" element={<MyAccessPage />} />
        <Route
          path="/admin/users"
          element={
            <ProtectedRoute adminOnly>
              <UsersPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/databases"
          element={
            <ProtectedRoute adminOnly>
              <DatabasesPage />
            </ProtectedRoute>
          }
        />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
